export const filterByEnabledKeys = (
    obj: Record<string, any>,
    enabledKeys: string[],
    keysSuffixToSubtract: string | string[] | null = null,
) => {
    if (!enabledKeys.length || !obj) return [];

    const filtered: Record<string, any> = {};

    for (const key of enabledKeys) {
        // for objects where keys are not currency pairs like 'BTCUSDT' | 'ETHUSDT'
        // but pure tokens like 'BTC' | 'ETH'

        // because in enabledKeys we always receive  currency pairs
        // but in some objects like on 'state.configV2.token' fields are always pure tokens
        // while on 'state.configV2.symbol' or 'state.configV2.futuresSymbol' we have currency pairs fields

        let baseKey = '';

        if (!keysSuffixToSubtract) {
            baseKey = key;
        }

        if (typeof keysSuffixToSubtract === 'string') {
            baseKey = key.replace(keysSuffixToSubtract as string, '');
        }

        if (Array.isArray(keysSuffixToSubtract)) {
            keysSuffixToSubtract.forEach((k) => {
                if (key.includes(k)) {
                    baseKey = key.replace(k, '');
                }
            });
        }

        if (baseKey in obj) {
            filtered[baseKey] = obj[baseKey];
        }
    }
    return filtered;
};
